var _filter, _linearGradient, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "css-2qgrgz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: ":r19:-filter",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 21,
    width: 20,
    x: 2,
    y: 2
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_651_209466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_651_209466",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r19:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3,
    x2: 20.9102,
    y1: 4.5158,
    y2: 20.7203
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Ui-outlineFilter",
    filter: "url(#:r19:-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m12 3c-4.97045 0-9 4.02955-9 9 0 4.9705 4.02955 9 9 9 4.9705 0 9-4.0295 9-9 0-4.97045-4.0295-9-9-9zm0 1.63636c1.8962 0 3.6198.72265 4.9251 1.90004l-1.5733.36435.012 3.31265 3.025 1.3479.815-1.0866c.1038.4924.1598 1.002.1598 1.5253 0 1.2122-.2977 2.353-.8165 3.3614l-.0951-.167-3.1697.9604-.3364 2.592c-.9026.3948-1.8977.6168-2.9459.6168-.2889 0-.5723-.0211-.8525-.0535l-1.50616-2.0758-2.28836.4746c-1.05144-.8569-1.85652-1.9993-2.30832-3.3079l1.26322-1.8832-1.4414-2.3156c.32869-1.30737.99889-2.47918 1.92161-3.40373l-.01119.33958 3.20481.83656 2.07899-2.57839-.5801-.73349c.1724-.01206.344-.02637.5194-.02637zm-1.6859 4.86994-2.50089 3.057 2.14613 3.2927 3.82646-1.0219.2197-3.9239z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 3c-4.97045 0-9 4.02955-9 9 0 4.9705 4.02955 9 9 9 4.9705 0 9-4.0295 9-9 0-4.97045-4.0295-9-9-9zm0 1.63636c1.8962 0 3.6198.72265 4.9251 1.90004l-1.5733.36435.012 3.31265 3.025 1.3479.815-1.0866c.1038.4924.1598 1.002.1598 1.5253 0 1.2122-.2977 2.353-.8165 3.3614l-.0951-.167-3.1697.9604-.3364 2.592c-.9026.3948-1.8977.6168-2.9459.6168-.2889 0-.5723-.0211-.8525-.0535l-1.50616-2.0758-2.28836.4746c-1.05144-.8569-1.85652-1.9993-2.30832-3.3079l1.26322-1.8832-1.4414-2.3156c.32869-1.30737.99889-2.47918 1.92161-3.40373l-.01119.33958 3.20481.83656 2.07899-2.57839-.5801-.73349c.1724-.01206.344-.02637.5194-.02637zm-1.6859 4.86994-2.50089 3.057 2.14613 3.2927 3.82646-1.0219.2197-3.9239z",
    fill: "url(#:r19:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-outline",
    d: "m18.2987 14.7184-3.1614.9579c-.1882.057-.3255.2191-.3508.4142l-.2992 2.305c-.7717.3011-1.6094.4681-2.4873.4681-.193 0-.3854-.0103-.5789-.0278l-1.3751-1.8951c-.11548-.1593-.31361-.2359-.50621-.196l-2.05028.4252c-.83168-.7267-1.48333-1.652-1.888-2.7015l1.12161-1.6721c.10957-.1634.11319-.3758.00924-.5428l-1.3269-2.1316c.26161-.92247.70689-1.76666 1.2981-2.48624l3.15187.82274c.19027.04968.39207-.01683.51547-.16994l2.0791-2.5784c.1291-.16018.1454-.38035.0484-.55573 1.2125.08772 2.336.49295 3.2927 1.13145l-.5521.12786c-.2273.05265-.388.25556-.3872.48891l.012 3.31265c.0007.1968.1168.3748.2965.4549l3.025 1.348c.2131.0949.4636.0299.6035-.1568l.0709-.0944c.0026.0774.0039.1551.0039.2331 0 .9664-.203 1.8842-.5649 2.7184zm-7.8069-5.67944c-.201-.07647-.4285-.01576-.5647.15075l-2.50089 3.05699c-.13793.1686-.15083.4071-.03188.5896l2.14613 3.2927c.11803.1811.33906.2658.54794.2101l3.8264-1.022c.2088-.0557.3581-.2393.3702-.4551l.2197-3.9239c.0122-.2175-.1178-.4179-.3215-.4953zm1.5082-6.53896c-5.2466 0-9.5 4.2534-9.5 9.5s4.2534 9.5 9.5 9.5 9.5-4.2534 9.5-9.5-4.2534-9.5-9.5-9.5z",
    stroke: "#5800e9",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.c808b6f6be231fd5c0918dd36dd3c1ee.svg";
export { ForwardRef as ReactComponent };